import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'Products', href: '/products' },
    { name: 'About Us', href: '/story' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <>
      {/* Top Scrolling Banner with Fancy Bottom */}
      <div className="text-kato-navy py-3 overflow-hidden relative" style={{ backgroundColor: '#F5ED3A' }}>
        <div className="animate-marquee whitespace-nowrap flex items-center">
          <span className="text-sm font-semibold inline-flex items-center mx-12">
            <span className="bg-white rounded-full p-1 mr-2">🍭</span> NEW! Custom Swedish-Style Candy Options Available
          </span>
          <span className="text-sm font-semibold inline-flex items-center mx-12">
            <span className="bg-white rounded-full p-1 mr-2">🌍</span> Join 500+ Global Partners Across 45+ Countries
          </span>
          <span className="text-sm font-semibold inline-flex items-center mx-12">
            <span className="bg-white rounded-full p-1 mr-2">🍭</span> NEW! Custom Swedish-Style Candy Options Available
          </span>
          <span className="text-sm font-semibold inline-flex items-center mx-12">
            <span className="bg-white rounded-full p-1 mr-2">🌍</span> Join 500+ Global Partners Across 45+ Countries
          </span>
        </div>
        {/* Liquid Flow Bottom */}
        <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none">
          <svg className="relative block w-full h-4" viewBox="0 0 1200 120" preserveAspectRatio="none">
            <path d="M0,120L1200,120L1200,20C1000,60 800,40 600,50C400,60 200,40 0,20Z" className="fill-white"></path>
          </svg>
        </div>
      </div>

      {/* Main Header */}
      <header className="shadow-lg sticky top-0 z-40" style={{ backgroundColor: '#4CC8ED' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 py-2">
            {/* Logo and Navigation on the Left */}
            <div className="flex items-center space-x-8">
              <Link to="/" className="flex items-center">
                <img 
                  src="https://customer-assets.emergentagent.com/job_kato-mito-upgrade/artifacts/llbvcjnh_IMG_0805.png" 
                  alt="Kato Mito" 
                  className="h-12 w-auto hover:scale-105 transition-transform duration-300"
                />
              </Link>
              
              {/* Navigation beside logo */}
              <nav className="hidden md:flex space-x-8">
                {navigation.map((item) => (
                  <Link
                    key={item.name}
                    to={item.href}
                    className={`text-xl font-bold transition-colors duration-200 hover:text-kato-yellow ${
                      isActive(item.href) 
                        ? 'border-b-3' 
                        : ''
                    }`}
                    style={{ color: '#221D58', borderBottomColor: isActive(item.href) ? '#221D58' : 'transparent' }}
                  >
                    {item.name}
                  </Link>
                ))}
              </nav>
            </div>

            {/* Mobile menu button */}
            <div className="md:hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="hover:text-kato-yellow transition-colors"
                style={{ color: '#221D58' }}
              >
                {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
              </button>
            </div>

            {/* Right Side Icons & CTA */}
            <div className="flex items-center space-x-4">
              {/* Contact Us Link */}
              <Link
                to="/contact"
                className="hidden md:block text-xl font-bold hover:text-kato-yellow transition-colors"
                style={{ color: '#221D58' }}
              >
                Contact Us
              </Link>
              
              {/* Phone Icon */}
              <div className="hidden md:flex items-center space-x-2">
                <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{ backgroundColor: '#221D58' }}>
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" style={{ color: '#4CC8ED' }}>
                    <path d="M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4A1,1 0 0,1 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z"/>
                  </svg>
                </div>
              </div>

              {/* Quote Us Button - Standout */}
              <Link
                to="/contact#quote"
                className="px-8 py-3 rounded-full text-xl font-black hover:scale-110 transition-all duration-300 hover:shadow-2xl animate-pulse shadow-lg"
                style={{ background: 'linear-gradient(to right, #F5ED3A, #00d4ff)', color: '#221D58' }}
              >
                Quote Us! 🍭
              </Link>
            </div>
          </div>

          {/* Mobile Navigation */}
          {isMenuOpen && (
            <div className="md:hidden py-4 border-t border-gray-200">
              <div className="flex flex-col space-y-4">
                {navigation.map((item) => (
                  <Link
                    key={item.name}
                    to={item.href}
                    onClick={() => setIsMenuOpen(false)}
                    className={`text-lg font-medium transition-colors duration-200 hover:text-kato-yellow ${
                      isActive(item.href) 
                        ? 'text-kato-navy font-semibold' 
                        : 'text-gray-700'
                    }`}
                  >
                    {item.name}
                  </Link>
                ))}
                <Link
                  to="/contact"
                  onClick={() => setIsMenuOpen(false)}
                  className="bg-kato-navy text-white px-6 py-3 rounded-full text-lg font-bold hover:bg-opacity-90 transition-all duration-200 w-fit"
                >
                  Get Quote
                </Link>
              </div>
            </div>
          )}
        </div>
      </header>
    </>
  );
};

export default Header;